// mindzera-frontend/src/main.jsx

import React from "react";
import ReactDOM from "react-dom/client";
import "katex/dist/katex.min.css";
import "./index.css";

async function loadRoot() {
  if (import.meta.env.VITE_ITCH_GAME === "sex-and-commitment") {
    const module = await import("./ItchSexAndCommitmentApp.jsx");
    const ItchSexAndCommitmentApp = module.default;

    return (
      <React.StrictMode>
        <ItchSexAndCommitmentApp />
      </React.StrictMode>
    );
  }

  const [{ default: App }, { AuthProvider }] = await Promise.all([
    import("./App.jsx"),
    import("./AuthContext.jsx"),
  ]);

  return (
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
}

loadRoot().then((rootElement) => {
  ReactDOM.createRoot(document.getElementById("root")).render(rootElement);
});